export const END_EMPLOYMENT_REASON_TYPES = {
  QUIT: 'QUIT',
  FIRED: 'FIRED',
} as const;

export const END_EMPLOYMENT_REASON_TEXT = {
  QUIT: 'Terminated - Voluntary',
  FIRED: 'Terminated - Involuntary',
} as const;
